export const themeStorageKey = '__theme__';
export const themes = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};
